module.exports = ":host {\n  display: contents;\n}"